import {Directive, forwardRef, Injector} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, NgControl, ValidationErrors, Validator} from '@angular/forms';
import {AppConfigService} from '@service/config/app-config.service';

// Matches: po box, pobox, p o box, p.o. box, p.o.box, p. o. box,
//          pob, p o b, p.o.b, post office box
const PO_BOX_REGEX = /\bp\.?\s*o\.?\s*(box|b)\b|\bpost\s+office\s+box\b/;

/**
 * True when the value looks like a PO Box and the institution does not allow PO Box addresses.
 * Use this where the PO Box check cannot be expressed as a control validator (e.g. controls whose
 * errors are set imperatively, like the `fullAddress` control in Flow2AddressComponent). Note this
 * does not apply the mailingAddressData exception below, since that's tied to which control the
 * directive is attached to, not to the value itself.
 */
export function isPoBoxNotAllowed(value: any): boolean {
    if (AppConfigService.config.poboxAllowed) {
        return false;
    }

    return PO_BOX_REGEX.test(value ? String(value).toLowerCase() : '');
}

@Directive({
    selector: '[pobox-allowed]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => PoboxAllowedDirective),
            multi: true
        }
    ]
})
export class PoboxAllowedDirective implements Validator {

    constructor(private injector: Injector) {
    }

    private get ngControl(): NgControl {
        return this.injector.get(NgControl);
    }

    validate(control: AbstractControl): ValidationErrors | null {
        // PO Box is explicitly allowed on the mailing address control.
        if (this.ngControl.name === 'mailingAddressData') {
            return null;
        }

        return isPoBoxNotAllowed(control.value) ? {'pobox-allowed': true} : null;
    }
}
